import { useMemo } from 'react'

import type User from 'modules/core/store/models/User'

import UserForm from 'modules/external_users/lib/forms/User'
import type PermissionGroup from 'modules/permissions/store/models/PermissionGroup'

interface Props {
  permissionGroup: PermissionGroup
  user: User | null | undefined
}

const useForm = ({ user, permissionGroup }: Props): UserForm => {
  return useMemo(() => {
    let data: Record<string, unknown> = {
      permissions_group_id: permissionGroup.attributes.id,
    }

    if (user) {
      data = {
        id: user.attributes.id,
        email: user.attributes.email,
        first_name: user.firstName,
        last_name: user.lastName,
        permissions_group_id: user.attributes.permissions_group_id,
        invited_on: user.attributes.invited_on,
      }
    }

    return new UserForm(data)
  }, [user, permissionGroup])
}

export default useForm
